import React, { useState } from 'react'
import Topbar from '../../components/Topbar/Topbar'
import { useLocation, useNavigate } from 'react-router-dom'
import DateRange from '../../components/DateRange/DateRange'
import { Search_icon } from '../../assets/img'
import { toast } from 'react-toastify'
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

const CancelApprView = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const [rejectPopup, setRejectPopup] = useState(false)
    const [reason, setReason] = useState('');
    const [popup, setPopup] = useState(false)
    const [desc, setDesc] = useState('');
    const [details, setDetails] = useState([]);


    const handleSubmit = () => {
        if (details.length == 0) {
            toast.error("Add Description")
            return
        }
        navigate('/property-details');
    };
    const handleReason = () => {
        if (!reason) {
            toast.error("Add Reason")
            return
        }
        setRejectPopup(false)
        setReason("")
    };
    const handleReject = () => {
        if (!desc) {
            toast.error("Enter Description");
            return
        }
        if (desc.trim() !== '') {
            setDetails([...details, desc.trim()])
            setDesc('');
            setPopup(false)
        }

    };

    return (
        <div className=''>
            <Topbar header={"MMC View"} subHead={"MMC Cancellation"} />
            <div className='d-flex flex-wrap gap-5 pb-4'>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Property ID </p>
                    <input className='input-box'
                        value={"Vow13243"}
                        type="text" placeholder='Property ID' />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Property Name</p>
                    <input className='input-box'
                        value={"Villa"}
                        type="text" placeholder='Property name' />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Owner Name</p>
                    <input className='input-box'
                        value={"Vignesh"}
                        type="text" placeholder='Owner Name' />
                </div>

                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>City</p>
                    <input
                        value={"Chennai"}
                        className='input-box' type="text" placeholder='Location' />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Type</p>
                    <input
                        value={"Villa"}
                        className='input-box' type="text" placeholder='Type' />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Requested Date</p>
                    <input
                        value={"19-08-2025"}
                        className='input-box' type="text" placeholder='Requested Date' />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Approved By</p>
                    <input
                        value={"Surya"} disabled
                        className='input-box' type="text" placeholder='Requested Date' />
                    <button className='active-btn p-2 mt-2'>Repay</button>
                </div>
                <div className='col-md-5 d-flex ac-jb'>
                    <div className='col-md-5'>
                        <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Approved Date</p>
                        <input
                            value={"19-08-2025"} disabled
                            className='input-box' type="text" placeholder='Approved Date' />
                    </div>
                    <div className='col-md-5'>
                        <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Approved Time</p>
                        <input
                            value={"19-08-2025"} disabled
                            className='input-box' type="text" placeholder='Approved Time' />
                    </div>
                </div>


            </div>
            <div className='d-flex ac-je mt-5 gap-3'>
                <DateRange />
                <div className='search-input'>
                    <input
                        //  onChange={(e) => (adminList(1, e.target.value))}
                        type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
                    <img src={Search_icon} className='search here' />
                </div>
                <button onClick={() => setPopup(true)} className='active-btn'>Add</button>
            </div>

            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className='d-flex ac-jb  mb-4'>
                            <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                                Description
                            </p>
                            <CloseSharpIcon onClick={() => { setPopup(false); setDesc("") }} className='pointer' />
                        </div>
                        <textarea style={{ minHeight: "130px", maxHeight: "300px" }} placeholder='Describe..' className='input-box' value={desc} onChange={(e) => setDesc(e.target.value)}></textarea>
                        <div className="d-flex ac-jc px-2 mt-4">
                            <button
                                onClick={() => {
                                    handleReject();
                                }}
                                className="submit-btn f2 w-40"
                            >
                                {/* {loading ? "Loading..." : "Confirm"} */}Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {rejectPopup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className='d-flex ac-jb  mb-4'>
                            <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                                Reason For Approve/Reject ?
                            </p>
                            <CloseSharpIcon onClick={() => { setRejectPopup(false); setReason("") }} className='pointer' />
                        </div>
                        <textarea style={{ minHeight: "130px", maxHeight: "300px" }} placeholder='Describe..' className='input-box' value={reason} onChange={(e) => setReason(e.target.value)}></textarea>
                        <div className="d-flex ac-jc px-2 mt-4">
                            <button
                                onClick={() => {
                                    handleReason();
                                }}
                                className="submit-btn f2 w-40"
                            >
                                {/* {loading ? "Loading..." : "Confirm"} */}Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className='mt-5'>
                <div className="d-flex ac-jb">
                    <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table'>Ticket ID</h4>
                    <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table'>Admin Name</h4>
                    <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-40 box-table'>Description</h4>
                    <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 gray w-20 box-table'>Date & Time</h4>
                </div>

                {details.map((item) => {
                    return (
                        <div className="d-flex ">
                            <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 red w-20 box-table'>ZT6SD4HO</h4>
                            <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table'>Midhun</h4>
                            <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-40 box-table'>{item}</h4>
                            <h4 className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  w-20 box-table'>08-07-2025, 12:35pm</h4>
                        </div>
                    )
                })}
            </div>





            <div className="d-flex ac-jb mt-5">
                <button onClick={() => navigate(-1)} className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                    Back
                </button>
                {/* {type != "view" && ( */}
                <button onClick={handleSubmit} className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                    Save
                </button>
                {/* )} */}
            </div>
        </div>
    )
}


export default CancelApprView